import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { Reveal, PageHero } from './LandingShared';
import { useTranslation } from '../contexts/TranslationContext';
import { ShieldCheckIcon } from '@heroicons/react/24/outline';
import { Helmet } from 'react-helmet-async';

/**
 * Compliance Component
 * A static page that details the company's compliance policies and procedures.
 * Features a modern gradient hero, animated card with accent line, and staggered
 * scroll-reveal animations for a professional, interactive presentation.
 */
const Compliance = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Helmet>
        <title>Compliance — Cogent Platform</title>
        <meta name="description" content="Learn about Cogent Asset Management's compliance policies and regulatory framework. Licensed and regulated under the Labuan Financial Services & Securities Act 2010." />
        <link rel="canonical" href="https://cogentplatform.com/compliances" />
      </Helmet>
      <Navbar />

      <main className="flex-grow">
        {/* Hero Banner */}
        <PageHero title={t('compliance.title')} />

        {/* Content Section */}
        <div className="bg-gradient-to-b from-white to-slate-50 py-16 sm:py-20">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <Reveal>
              <div className="rounded-2xl border border-gray-100 shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden">
                {/* Gradient accent line */}
                <div className="h-1 bg-gradient-to-r from-blue-600 to-cyan-500 rounded-t-2xl" />

                <div className="p-8 sm:p-12">
                  {/* Shield icon in gradient container */}
                  <div className="flex justify-center mb-8">
                    <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-blue-600 to-cyan-500 flex items-center justify-center shadow-lg shadow-blue-500/20">
                      <ShieldCheckIcon className="w-8 h-8 text-white" />
                    </div>
                  </div>

                  <div className="prose prose-lg max-w-none text-gray-700 leading-8 text-justify space-y-6">
                    <Reveal delay={0}>
                      <p>{t('compliance.paragraph1')}</p>
                    </Reveal>
                    <Reveal delay={100}>
                      <p>{t('compliance.paragraph2')}</p>
                    </Reveal>
                    <Reveal delay={200}>
                      <p>{t('compliance.paragraph3')}</p>
                    </Reveal>
                    <Reveal delay={300}>
                      <p>{t('compliance.paragraph4')}</p>
                    </Reveal>
                  </div>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Compliance;
